import React from 'react'

export default function ArrowRightChevronIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.33325 4.6665L9.66659 7.99984L6.33325 11.3332" stroke="#071013" strokeOpacity="0.5"/>
</svg>

  )
}
